export const AUTHORISATION_OVERRIDE_REQUEST_ACTION = 'override';
export const AUTHORISATION_REQUEST_ACTION = 'authorise';
export enum DIAGRAM_VERSION_STATES_ENUM {
  DRAFT = 'draft',
  BEING_AUTHORISED = 'being_authorised',
  READY = 'ready',
  MASTER = 'master',
  ARCHIVE = 'archive',
  NEVER_PUBLISHED = 'never_published',
  CANCELLED = 'cancelled'
}
